import React, { useEffect, useState } from "react";
import Utility from "../../common/utility";
import ApiCalls from "../apis/api-calls";
import { inject, observer } from "mobx-react";

const Expiration = inject("sharedStore")(
  observer((store) => {
    const {
      sharedStore,
      history,
      location: { pathname, state },
    } = store;
    const [isResend, setResend] = useState(false);
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const user_id = Utility.getData("user_id");

    useEffect(() => {
      setTimeout(() => setButtonDisabled(true), 30000);
      setResend(Utility.getData("emailSent"));
    }, []);

    const goToLogin = (e) => {
      history.push("/");
    };

    const goToRequestAccess = () => {
      history.push("request-access");
    };

    const handleResendVerification = (e) => {
      sharedStore.showLoader();
      return ApiCalls.resendVerificationCode({
        user_id: user_id,
      }).then((response) => {
        sharedStore.hideLoader();
        Utility.setData("emailSent", true);
        if (response && response.error === false) {
          setTimeout(() => setButtonDisabled(false), 30000);
          setResend(true);
          setButtonDisabled(true);
        } else {
          if (response.status_code === 409) {
            history.push("/thankyou", { status: "verified" });
          } else {
            history.push("/verification-expired", { error: true });
          }
        }
      });
    };

    return (
      <React.Fragment>
        {state &&
        state.status === "error" &&
        pathname === "/verification-expired" ? (
          <div className="loginBackground">
            <div className="verification_expired">
              <div className="leftverexp">
                <h1>Welcome to the Izenda Customer Portal </h1>
              </div>
              <div className="rightverexp">
                <div className="vertxt">
                  <p className="vertitle">
                    Oops! Your verification link has expired.
                  </p>
                  {isResend ? (
                    <p className="resndexplink  extraSpaceTitle">
                      Email re-sent. Check your inbox and click the link to activate your account.
                    </p>
                  ) : null}
                  {!isResend ? (
                    <button
                      className={"btn-resend enable"}
                      onClick={(e) => handleResendVerification(e)}
                    >                      
                      Re-send email verification
                    </button>
                  ) : isResend && !isButtonDisabled ? (
                    <button
                      className={"btn-resend"}
                      disabled={isButtonDisabled}
                      onClick={(e) => handleResendVerification(e)}
                    >
                      {" "}
                      Re-send email verification
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {state &&
        state.status === "active" &&
        pathname === "/account-verification" ? (
          <div className="loginBackground">
            <div className="verification_expired">
              <div className="leftverexp">
                <h1>Welcome to the Izenda Customer Portal </h1>
              </div>
              <div className="rightverexp">
                <div className="vertxt">
                  <p className="vertitle">Account Verification Needed</p>
                  <p className="resndexplink extraSpaceTitle">
                    Almost done! We have sent a verification email to the email
                    address associated with your account. Please verify your
                    account by clicking the link provided in the email.
                  </p>
                  {!isResend ? (
                    <button
                      className={
                        !isButtonDisabled
                          ? "btn-resend disabled"
                          : "btn-resend enable"
                      }
                      disabled={!isButtonDisabled}
                      onClick={(e) => handleResendVerification(e)}
                    >
                      Re-send verification
                    </button>
                  ) : (
                    <span>
                      Email re-sent{" "}
                      <button
                        className={
                          isButtonDisabled
                            ? "btn-resend disabled"
                            : "btn-resend enable"
                        }
                        disabled={isButtonDisabled}
                        onClick={(e) => handleResendVerification(e)}
                      >
                        {" "}
                        Send Again
                      </button>{" "}
                    </span>
                  )}
                  <p className="resndexpText">
                    Please give email up to 5 minutes to appear in your inbox.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {state && state.status === "expired" ? (
          <div className="loginBackground">
            <div className="verification_expired">
              <div className="leftverexp">
                <h1>Welcome to the Izenda Customer Portal </h1>
              </div>
              <div className="rightverexp">
                <div className="vertxt">
                  <p className="vertitle  extraSpaceTitle">
                    Oops! This link has already been used. Please check your
                    inbox for another email to verify your account
                  </p>
                  {!isResend ? (
                    <button
                      className={
                        isButtonDisabled ? "btn-resend grey-text" : "btn-resend"
                      }
                      onClick={(e) => handleResendVerification(e)}
                    >
                      Re-send Account Verification Email
                    </button>
                  ) : (
                    <span>
                      Email re-sent{" "}
                      <button
                        className={
                          isButtonDisabled
                            ? "btn-resend disabled"
                            : "btn-resend enable"
                        }
                        disabled={isButtonDisabled}
                        onClick={(e) => handleResendVerification(e)}
                      >
                        {" "}
                        Send Again
                      </button>{" "}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {state && state.status === "request-access" ? (
          <div className="loginBackground">
            <div className="verification_expired">
              <div className="leftverexp">
                <h1>Welcome to the Izenda Customer Portal </h1>
              </div>
              <div className="rightverexp">
                <div className="vertxt">
                  <p className="vertitle">
                    Oops! Your invitation link has expired
                  </p>
                  <button
                    className={"btn-resend"}
                    onClick={(e) => goToRequestAccess(e)}
                  >
                    Request Another invitation
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {state && state.status === "token_used" ? (
          <div className="loginBackground">
            <div className="verification_expired">
              <div className="leftverexp">
                <h1>Welcome to the Izenda Customer Portal </h1>
              </div>
              <div className="rightverexp">
                <div className="vertxt">
                  {pathname === "/verification-expired" ? (
                    <p className="vertitle  extraSpaceTitle">
                      Oops! This link has already been used. Your account has
                      already been verified.
                    </p>
                  ) : (
                    <p className="vertitle  extraSpaceTitle">
                      Oops! This link has already been used. Your account has
                      already been registered and verified.
                    </p>
                  )}

                  <button
                    className={"btn btn-common btn-profile-lg"}
                    onClick={(e) => goToLogin(e)}
                  >
                    Log In
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {state && state.status ? null : <div>Page Not Found</div>}
      </React.Fragment>
    );
  })
);

export default Expiration;



// WEBPACK FOOTER //
// ./src/components/Expiration/Expiration.jsx